// @ts-nocheck
/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file
import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Bishal Niroula",
  title: "Hello, I'm Bishal.",
  subTitle: emoji(
    "I work full-stack on software that carries real weight, from serverless systems moving eight-figure revenue to court and government workflows people depend on. 🚀"
  ),
  // Rendered as a GitHub-style diffstat badge beside this line (see Greeting.tsx)
  subTitlePR: {
    text: "My best PRs have a negative diff.",
    additions: 87,
    deletions: 653
  },
  subTitleClosing: "Open to the next hard problem!",
  resumeLink: "/Bishal_Niroula_Resume.pdf", // Set to empty to hide the button
  scheduleLink: "https://cal.com/bishal-niroula/30min", // Cal.com / Calendly URL. Set to empty to hide the button.
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/bniroula",
  linkedin: "https://www.linkedin.com/in/bishal-niroula/",
  gmail: "bishal.nir24@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK ENGINEER WHO LOVES TO EXPLORE NEW TECH",
  skills: [
    emoji(
      "⚡ Build event-driven systems on AWS serverless (Lambda, SNS, SQS, DynamoDB) that move real revenue"
    ),
    emoji(
      "⚡ Run zero-downtime data migrations across production DynamoDB at millions-of-rows scale"
    ),
    emoji(
      "⚡ Design multi-tenant SaaS architecture with service boundaries, tenant isolation, cross-cutting integrations"
    ),
    emoji(
      "⚡ Ship government and court workflows with real-time integrations to external state systems"
    ),
    emoji(
      "⚡ Ingest and process Kafka streams at scale to power booking, notification, and pricing flows"
    ),
    emoji(
      "⚡ Design API contracts, data models, and event schemas with versioning, backwards compatibility, and access-pattern-first thinking"
    ),
    emoji(
      "⚡ Debug like a detective in a mystery where I'm also the culprit"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      category: "AI Development Tools",
      items: [
        {
          skillName: "Kiro",
          icon: "https://kiro.dev/icon.svg"
        },
        {
          skillName: "Claude Code",
          icon: "https://cdn.simpleicons.org/claude"
        },
        {
          skillName: "GitHub Copilot",
          icon: "https://cdn.simpleicons.org/githubcopilot"
        },
        {
          skillName: "MCP",
          icon: "https://cdn.simpleicons.org/modelcontextprotocol/645beb"
        }
      ]
    },
    {
      category: "Cloud & Infrastructure",
      items: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "fab fa-aws"
        },
        {
          skillName: "Azure",
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg"
        },
        {
          skillName: "GCP",
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg"
        },
        {
          skillName: "Terraform",
          icon: "https://cdn.simpleicons.org/terraform"
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "fab fa-docker"
        },
        {
          skillName: "GitHub Actions",
          icon: "https://cdn.simpleicons.org/githubactions"
        }
      ]
    },
    {
      category: "Languages",
      items: [
        {
          skillName: "Java",
          fontAwesomeClassname: "fab fa-java"
        },
        {
          skillName: "TypeScript",
          icon: "https://cdn.simpleicons.org/typescript"
        },
        {
          skillName: "C#",
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg"
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "fab fa-python"
        }
      ]
    },
    {
      category: "Data & Events",
      items: [
        {
          skillName: "Kafka",
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg"
        },
        {
          skillName: "DynamoDB",
          icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dynamodb/dynamodb-original.svg"
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "fas fa-database"
        },
        {
          skillName: "Elasticsearch",
          icon: "https://cdn.simpleicons.org/elasticsearch"
        },
        {
          skillName: "Flyway",
          icon: "https://cdn.simpleicons.org/flyway"
        }
      ]
    },
    {
      category: "Frameworks & Tools",
      items: [
        {
          skillName: "React",
          fontAwesomeClassname: "fab fa-react"
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "fab fa-node"
        },
        {
          skillName: "Spring Boot",
          icon: "https://cdn.simpleicons.org/spring"
        },
        {
          skillName: "Quarkus",
          icon: "https://cdn.simpleicons.org/quarkus"
        },
        {
          skillName: "GraphQL",
          icon: "https://cdn.simpleicons.org/graphql"
        },
        {
          skillName: "Splunk",
          icon: "https://cdn.simpleicons.org/splunk"
        },
        {
          skillName: "Drupal",
          fontAwesomeClassname: "fab fa-drupal"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Troy University",
      logo: require("./assets/images/troy_logo.jpg"),
      subHeaders: ["Bachelor of Science in Computer Science","Minors: Physics, Mathematics"],
      duration: "January 2017 - December 2020",
      desc: "Graduated Summa Cum Laude",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "50%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer Architect",
      company: "Slalom",
      companylogo: require("./assets/images/slalom.png"),
      date: "Sep 2026 – Present",
      desc: "Architect on client engagement",
      descBullets: [
        "Architected a multi-agent development pipeline automating Jira-to-PR delivery through specialized planning, implementation, and review agents, with HITL approvals and adversarial verification, improving team velocity by ~20%.",
        "Engineered MCP-based tool integrations across Jira, Confluence, Figma, and GitHub, enabling AI agents to retrieve project context, execute structured tool calls, and automate development workflows from requirements through pull-request creation.",
        "Led technical discovery and solution design for complex features, resolving architectural ambiguities and coordinating cross-team dependencies to unblock delivery."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Slalom",
      companylogo: require("./assets/images/slalom.png"),
      date: "Jul 2022 – Aug 2026",
      desc: "Senior Engineer on client engagements",
      descBullets: [
        "Applied context engineering techniques to AI-assisted development, leveraging repository documentation, architectural patterns, and coding standards to improve code generation, refactoring, and testing.",
        "Scoped, planned, and shipped full-stack features on a statewide multi-tenant court case management system live across multiple jurisdictions, from refinement and estimation through production release.",
        "Built judicial case lifecycle, firearms and marriage licensing, and vital records workflows with real-time integrations to external state government systems.",
        "Helped shape service boundaries and the data model, and defined how the platform integrates with auth, reporting, document management, finance, and workflow orchestration.",
        "Built an event-driven price/inventory subscription system with the team on AWS Lambda, SNS, SQS, and DynamoDB, lifting bookings by 6% and adding $30M in quarterly revenue.",
        "Designed and built a serverless migration service that transformed millions of production DynamoDB records into a new table with zero downtime, unblocking a feature that required a new access pattern.",
        "Built a Kafka ingestion pipeline with the team on AWS serverless components that processed millions of messages per day, enabling add-on offerings to be folded into the booking flow and lifting attach rates by 13%."
      ]
    },
    {
      role: "Software Engineer",
      company: "Slalom Build",
      companylogo: require("./assets/images/slalom.png"),
      date: "Feb 2021 – Jul 2022",
      desc: "Embedded with client engineers on a payments platform",
      descBullets: [
        "Built a microservices-based credit card payment system with client engineers for the business customers of the largest US home improvement retailer, processing ~$6.5M in transactions per week.",
        "Owned the Card Request service end to end, letting business customers apply for a line of credit and moving applications through to card issuance.",
        "Built the Card service that tracks the lifecycle of every outstanding card from issuance to expiration/reissue, credit limits, deactivation, and organization-level controls.",
        "Helped build the Auth and Order services with an event-driven flow on Google Pub/Sub, authorizing each order against a cardholder's available balance and capturing funds only once the order was fulfilled."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Slalom",
      companylogo: require("./assets/images/slalom.png"),
      date: "Jun 2020 – Aug 2020",
      desc: "Shipped features for an internal publishing platform",
      descBullets:[
        "Built features for Slalom's internal, Medium-style article platform used by ~13,000 employees to write and share content.",
        "Added in-browser cropping for uploaded article images, letting authors frame visuals without leaving the editor.",
        "Implemented edit-locking that limits each article to one active editor at a time, preventing lost work from concurrent edits.",
        "Prototyped a headless Drupal + React architecture to decouple the CMS from the frontend."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Alfa Insurance",
      companylogo: require("./assets/images/Insurance-alfa.png"),
      date: "Jun 2019 – Jul 2019",
      desc: "Internship building a chatbot",
      descBullets:[
        "Built and deployed a claim-intake chatbot serving as the first touchpoint for policyholders after an incident.",
        "Tuned conversation flow using Microsoft LUIS and sentiment analysis, increasing test-user engagement by 50% and reducing claim filing time in half."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  projects: [
    {
      image: require("./assets/images/football.png"),
      projectName: "FIFA Rankings vs. World Cup Outcomes",
      projectDesc:
        "Interactive dashboard testing how well pre-tournament FIFA rankings predict World Cup match outcomes across 1994–2026. Built with React and Nivo.",
      footerLink: [
        {
          name: "View Dashboard",
          url: "/fifa-analysis"
        }
      ]
    },
    {
      image: require("./assets/images/hermes.jpeg"),
      projectName: "Project Hermes",
      projectDesc: "Engineered a traffic simulation using Python showcasing an 11% reduction in emissions and 4% increase in throughput via AI-driven traffic light optimization. Collaborated with Chicago Dept. of Transportation for real-world application planning.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://hackathon.slalom.com/teams/project-hermes"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/iblink.png"),
      projectName: "iBlink",
      projectDesc: "Developed an eye-controlled typing system with OpenCV, translating eye blinks to Morse code for text input, enhancing accessibility for users with limited mobility.",
      footerLink: [
        {
          name: "Github",
          url: "https://github.com/bniroula/iBlink"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications"),
  achievementsCards: [
    {
      title: "AWS Solutions Architect Associate",
      image: require("./assets/images/aws_associate.png"),
      imageAlt: "AWS Solutions Architect Associate Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/155a921d-6d21-42d1-96a0-9efc05bca2e3"
        }
      ]
    },
    {
      title: "Salesforce Certified AI Associate",
      image: require("./assets/images/salesforce.png"),
      imageAlt: "Salesforce Certified AI Associate Logo",
      footerLink:[]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to discuss an interesting opportunity or just want to say hi? My Inbox is open for all.",
  email_address: "bishal.nir24@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo,
  twitterDetails,
  isHireable
};
